import React from "react";

import { Route } from "react-router-dom";

import PreviewEditPanes from "@app/component/Layout/components/PreviewEditPanes";
import Path from "@app/enum/Path";
import { entityLinkGetterForIframes } from "@app/util/contexts/defaultEntityLinkGetter";
import EntityLinkGetterContext from "@app/util/contexts/EntityLinkGetterContext";

import CompanyRecordPage from "./CompanyRecordPage";
import CreateActivityPage from "./CreateActivityPage";
import CreateCompanyPage from "./CreateCompanyPage";
import CreateDealPage from "./CreateDealPage";
import CreatePersonPage from "./CreatePersonPage";
import DealRecordPage from "./DealRecordPage";
import EditActivityPage from "./EditActivityPage";
import PersonRecordPage from "./PersonRecordPage";

interface Props {}

const Web1Page: React.FC<Props> = () => {
  return (
    <EntityLinkGetterContext.Provider value={entityLinkGetterForIframes}>
      <PreviewEditPanes />
      <Route path={`${Path.WEB_1}${Path.COMPANY}/add`} component={CreateCompanyPage} />
      <Route path={`${Path.WEB_1}${Path.COMPANY}/:cid(\\d+)`} component={CompanyRecordPage} />
      <Route path={`${Path.WEB_1}${Path.PEOPLE}/add`} component={CreatePersonPage} />
      <Route path={`${Path.WEB_1}${Path.PEOPLE}/:pid(\\d+)`} component={PersonRecordPage} />
      <Route path={`${Path.WEB_1}${Path.DEAL}/add`} component={CreateDealPage} />
      <Route path={`${Path.WEB_1}${Path.DEAL}/:did(\\d+)`} component={DealRecordPage} />
      <Route path={`${Path.WEB_1}/activities/add`} component={CreateActivityPage} />
      <Route path={`${Path.WEB_1}/activities/edit/:aid`} component={EditActivityPage} />
    </EntityLinkGetterContext.Provider>
  );
};

export default Web1Page;
